import Vue from "vue";
import VueI18n, { Locale, LocaleMessageObject } from "vue-i18n";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "./types";

Vue.use(VueI18n);

const loadTranslations = () => {
  const messages: { [key: Locale]: LocaleMessageObject } = {};

  Object.keys(SUPPORTED_LOCALES).forEach(async (locale) => {
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires, import/no-dynamic-require
    messages[locale] = require(`./lang/${locale}.json`);
  });

  return messages;
};

const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: loadTranslations(),
});

export default i18n;
